// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__9wfLK","input":"Input_input__xuWPx","textarea":"Input_textarea__6f8q2","label":"Input_label__vbmY2","error":"Input_error__9trOF"};